<template>
  <section class="section pt-5">
    <messages-datatable />
  </section>
</template>

<script>
import MessagesDatatable from "./messages_datatable/Index.vue";

export default {
  name: "OutboxMessages",
  components: {
    MessagesDatatable,
  },
  data() {
    return {};
  },
  methods: {
    retrieve_settings() {
      // get_configuration(this)
      //   .then((conf) => {
      //     console.log("configuration retrieved", conf);
      //   })
      //   .catch((error) => {
      //     console.error(error);
      //   });
    },
    create() {
      console.log("create order");
    },
    refresh() {
      console.log("refresh orders");
    },
  },
  mounted() {},
  created() {},
};
</script>

<style scoped></style>
